/**
 * Forms Services Module
 * Exports all Forms Management services and the factory function.
 * Backend: CCMS.Api.FormsManagement (servicePath `forms`).
 */
import { FormsService } from './FormsService';
import { FormCategoriesService } from './FormCategoriesService';
import { FormSeriesService } from './FormSeriesService';
import { FormsModuleSettingsService } from './FormsModuleSettingsService';
import { FormEntriesService } from './FormEntriesService';
import { FormWebhooksService } from './FormWebhooksService';
import { PublicFormsService } from './PublicFormsService';
import { FormsExternalService } from './FormsExternalService';
export { FormsService, FormCategoriesService, FormSeriesService, FormsModuleSettingsService, FormEntriesService, FormWebhooksService, PublicFormsService, FormsExternalService, };
/**
 * Create all Forms Management services with shared configuration.
 */
export function createFormsServices(http, config) {
    return {
        forms: new FormsService(http, config),
        formCategories: new FormCategoriesService(http, config),
        formSeries: new FormSeriesService(http, config),
        formsModuleSettings: new FormsModuleSettingsService(http, config),
        formEntries: new FormEntriesService(http, config),
        formWebhooks: new FormWebhooksService(http, config),
        publicForms: new PublicFormsService(http, config),
        formsExternal: new FormsExternalService(http, config),
    };
}
//# sourceMappingURL=index.js.map